<template>
	<div class="main">
		<h2>Кабинет преподавателя</h2>
		<back></back>
		<!-- <router-link class="contest-btn" to="/matrius">
      <i class="fas fa-award"></i> Битва Матриуса
    </router-link> -->
		<ul class="uk-child-width-1-4@s uk-grid-match uk-flex-center" uk-grid>
      <li>
        <router-link to="/trainers">
          <div class="maincontent__item">
            <p>Тренажеры</p>
          </div>
        </router-link>
      </li>

			<li>
        <router-link to="/matrius-news">
          <div class="maincontent__item">
            <p>Новости Матриуса</p>
          </div>
        </router-link>
      </li>
			<li>
				<router-link to="/classes">
					<div class="maincontent__item">
						<p>Мои классы</p>
					</div>
				</router-link>
			</li>
			<li>
				<router-link to="/students">
					<div class="maincontent__item">
						<p>Мои ученики</p>
					</div>
				</router-link>
			</li>
			<li v-if="!user.is_outside && !user.is_course">
				<router-link to="/unattached">
					<div class="maincontent__item">
						<p>Распределение учеников</p>
					</div>
				</router-link>
			</li>			

      <li v-if="user.is_outside">
        <router-link to="/ot-anketa">
          <div class="maincontent__item">
            <p>НАСТРОЙКИ</p>
          </div>
        </router-link>
      </li>

		</ul>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
  export default {
    name: "maincomponent",
    computed: {
			...mapGetters({
				user: 'user'
			})
    }
  }
</script>
